import React, { useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { addDatabaseStreamActionCreator } from './storage'

import { Router, Route } from "react-router-dom";
import { createBrowserHistory } from "history";
import PrivateRoute from "./components/PrivateRoute.jsx";

import LoginPage from './pages/LoginPage'
import HomePage from './pages/HomePage'
import StreamPage from './pages/StreamPage'

import firebase from 'firebase';
import { firebaseConfig } from './dbconfig'
import { Stream } from './types';

export const history = createBrowserHistory();



function App() {

  let DB_APP: any = null;
  let database: any = null;
  const dispatch = useDispatch();

  useEffect( () => {
    //const streams = useSelector( (state: DbState) => { return state.Db } )


    DB_APP = firebase.initializeApp(firebaseConfig);
    database = DB_APP.database().ref('shoppings')

    firebase.analytics();

    database.on('value', (snap:any) => {
      const streamsList = snap.val();

      for(const streamObj in streamsList){
        dispatch(addDatabaseStreamActionCreator(streamsList[streamObj]))
      }

    })
  }, [] )

  return (
    <div className="App">
        <Router history={history}>
          <Route exact path="/" component={LoginPage} />
          <Route path="/stream_details" component={StreamPage}/>
          <PrivateRoute exact path="/Home" component={HomePage} />
      </Router>
    </div>
  );
}

export default App;
